(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 91535:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2z"
}), 'Circle');
exports.Z = _default;

/***/ }),

/***/ 35088:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
}), 'ColorLensRounded');
exports.Z = _default;

/***/ }),

/***/ 52778:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5-1-1h-5l-1 1H5v2h14V4h-3.5z"
}), 'DeleteOutlineOutlined');
exports.Z = _default;

/***/ }),

/***/ 47433:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m12 5.5 6 4.5v9H6v-9l6-4.5M12 3 4 9v12h16V9l-8-6zm-.5 6.5v3H11v-3h-1v3h-.5v-3h-1v3c0 .83.67 1.5 1.5 1.5v4h1v-4c.83 0 1.5-.67 1.5-1.5v-3h-1zm1.5 2v3h1V18h1V9.5c-1.1 0-2 .9-2 2z"
}), 'FoodBankOutlined');
exports.Z = _default;

/***/ }),

/***/ 76403:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'Grade');
exports.Z = _default;

/***/ }),

/***/ 2548:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
}), 'InfoOutlined');
exports.Z = _default;

/***/ }),

/***/ 15398:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person');
exports.Z = _default;

/***/ }),

/***/ 6585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63366);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98885);
/* harmony import */ var _styles_useTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2734);
/* harmony import */ var _transitions_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30577);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51705);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';



const _excluded = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];








const styles = {
  entering: {
    transform: 'none'
  },
  entered: {
    transform: 'none'
  }
};

/**
 * The Zoom transition can be used for the floating variant of the
 * [Button](/material-ui/react-button/#floating-action-buttons) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
const Zoom = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Zoom(props, ref) {
  const theme = (0,_styles_useTheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  const defaultTimeout = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      addEndListener,
      appear = true,
      children,
      easing,
      in: inProp,
      onEnter,
      onEntered,
      onEntering,
      onExit,
      onExited,
      onExiting,
      style,
      timeout = defaultTimeout,
      // eslint-disable-next-line react/prop-types
      TransitionComponent = react_transition_group__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, _excluded);
  const nodeRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  const handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(nodeRef, children.ref, ref);
  const normalizedTransitionCallback = callback => maybeIsAppearing => {
    if (callback) {
      const node = nodeRef.current;

      // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
      if (maybeIsAppearing === undefined) {
        callback(node);
      } else {
        callback(node, maybeIsAppearing);
      }
    }
  };
  const handleEntering = normalizedTransitionCallback(onEntering);
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_6__/* .reflow */ .n)(node); // So the animation always start from the start.

    const transitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_6__/* .getTransitionProps */ .C)({
      style,
      timeout,
      easing
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const transitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_6__/* .getTransitionProps */ .C)({
      style,
      timeout,
      easing
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);
    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);
  const handleAddEndListener = next => {
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TransitionComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    appear: appear,
    in: inProp,
    nodeRef: nodeRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    timeout: timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
          transform: 'scale(0)',
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, styles[state], style, children.props.style),
        ref: handleRef
      }, childProps));
    }
  }));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Zoom);

/***/ }),

/***/ 29387:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t={year:0,month:1,day:2,hour:3,minute:4,second:5},e={};return function(n,i,o){var r,a=function(t,n,i){void 0===i&&(i={});var o=new Date(t),r=function(t,n){void 0===n&&(n={});var i=n.timeZoneName||"short",o=t+"|"+i,r=e[o];return r||(r=new Intl.DateTimeFormat("en-US",{hour12:!1,timeZone:t,year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",second:"2-digit",timeZoneName:i}),e[o]=r),r}(n,i);return r.formatToParts(o)},u=function(e,n){for(var i=a(e,n),r=[],u=0;u<i.length;u+=1){var f=i[u],s=f.type,m=f.value,c=t[s];c>=0&&(r[c]=parseInt(m,10))}var d=r[3],l=24===d?0:d,h=r[0]+"-"+r[1]+"-"+r[2]+" "+l+":"+r[4]+":"+r[5]+":000",v=+e;return(o.utc(h).valueOf()-(v-=v%1e3))/6e4},f=i.prototype;f.tz=function(t,e){void 0===t&&(t=r);var n=this.utcOffset(),i=this.toDate(),a=i.toLocaleString("en-US",{timeZone:t}),u=Math.round((i-new Date(a))/1e3/60),f=o(a,{locale:this.$L}).$set("millisecond",this.$ms).utcOffset(15*-Math.round(i.getTimezoneOffset()/15)-u,!0);if(e){var s=f.utcOffset();f=f.add(n-s,"minute")}return f.$x.$timezone=t,f},f.offsetName=function(t){var e=this.$x.$timezone||o.tz.guess(),n=a(this.valueOf(),e,{timeZoneName:t}).find((function(t){return"timezonename"===t.type.toLowerCase()}));return n&&n.value};var s=f.startOf;f.startOf=function(t,e){if(!this.$x||!this.$x.$timezone)return s.call(this,t,e);var n=o(this.format("YYYY-MM-DD HH:mm:ss:SSS"),{locale:this.$L});return s.call(n,t,e).tz(this.$x.$timezone,!0)},o.tz=function(t,e,n){var i=n&&e,a=n||e||r,f=u(+o(),a);if("string"!=typeof t)return o(t).tz(a);var s=function(t,e,n){var i=t-60*e*1e3,o=u(i,n);if(e===o)return[i,e];var r=u(i-=60*(o-e)*1e3,n);return o===r?[i,o]:[t-60*Math.min(o,r)*1e3,Math.max(o,r)]}(o.utc(t,i).valueOf(),f,a),m=s[0],c=s[1],d=o(m).utcOffset(c);return d.$x.$timezone=a,d},o.tz.guess=function(){return Intl.DateTimeFormat().resolvedOptions().timeZone},o.tz.setDefault=function(t){r=t}}}));

/***/ }),

/***/ 70178:
/***/ (function(module) {

!function(t,i){ true?module.exports=i():0}(this,(function(){"use strict";var t="minute",i=/[+-]\d\d(?::?\d\d)?/g,e=/([+-]|\d\d)/g;return function(s,f,n){var u=f.prototype;n.utc=function(t){var i={date:t,utc:!0,args:arguments};return new f(i)},u.utc=function(i){var e=n(this.toDate(),{locale:this.$L,utc:!0});return i?e.add(this.utcOffset(),t):e},u.local=function(){return n(this.toDate(),{locale:this.$L,utc:!1})};var o=u.parse;u.parse=function(t){t.utc&&(this.$u=!0),this.$utils().u(t.$offset)||(this.$offset=t.$offset),o.call(this,t)};var r=u.init;u.init=function(){if(this.$u){var t=this.$d;this.$y=t.getUTCFullYear(),this.$M=t.getUTCMonth(),this.$D=t.getUTCDate(),this.$W=t.getUTCDay(),this.$H=t.getUTCHours(),this.$m=t.getUTCMinutes(),this.$s=t.getUTCSeconds(),this.$ms=t.getUTCMilliseconds()}else r.call(this)};var a=u.utcOffset;u.utcOffset=function(s,f){var n=this.$utils().u;if(n(s))return this.$u?0:n(this.$offset)?a.call(this):this.$offset;if("string"==typeof s&&(s=function(t){void 0===t&&(t="");var s=t.match(i);if(!s)return null;var f=(""+s[0]).match(e)||["-",0,0],n=f[0],u=60*+f[1]+ +f[2];return 0===u?0:"+"===n?u:-u}(s),null===s))return this;var u=Math.abs(s)<=16?60*s:s,o=this;if(f)return o.$offset=u,o.$u=0===s,o;if(0!==s){var r=this.$u?this.toDate().getTimezoneOffset():-1*this.utcOffset();(o=this.local().add(u+r,t)).$offset=u,o.$x.$localOffset=r}else o=this.utc();return o};var h=u.format;u.format=function(t){var i=t||(this.$u?"YYYY-MM-DDTHH:mm:ss[Z]":"");return h.call(this,i)},u.valueOf=function(){var t=this.$utils().u(this.$offset)?0:this.$offset+(this.$x.$localOffset||this.$d.getTimezoneOffset());return this.$d.valueOf()-6e4*t},u.isUTC=function(){return!!this.$u},u.toISOString=function(){return this.toDate().toISOString()},u.toString=function(){return this.toDate().toUTCString()};var l=u.toDate;u.toDate=function(t){return"s"===t&&this.$offset?n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate():l.call(this)};var c=u.diff;u.diff=function(t,i,e){if(t&&this.$u===t.$u)return c.call(this,t,i,e);var s=this.local(),f=n(t).local();return c.call(s,f,i,e)}}}));

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(73707);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 89243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99226);
/* harmony import */ var _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24849);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97734);





var NoDataUI = function(param) {
    var Icon = param.Icon, _iconSize = param.iconSize, iconSize = _iconSize === void 0 ? 50 : _iconSize, displayMessage = param.displayMessage, sx = param.sx;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            minHeight: "400px",
            flexDirection: "column",
            gap: 2,
            boxSizing: "border-box"
        }, sx),
        children: [
            Icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                sx: {
                    color: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.whiteBg.WBG4 */ .r.whiteBg.WBG4,
                    fontSize: iconSize
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                variant: "title4",
                sx: {
                    color: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.whiteBg.WBG4 */ .r.whiteBg.WBG4
                },
                children: displayMessage
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NoDataUI);


/***/ }),

/***/ 30894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* reexport */ BannerImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(88078);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(91444);
// EXTERNAL MODULE: ./assets/Icons/EditIcon.tsx
var EditIcon = __webpack_require__(95905);
// EXTERNAL MODULE: ./firebase/user.ts + 3 modules
var user = __webpack_require__(32012);
// EXTERNAL MODULE: ./mui-customs/Theme.ts
var Theme = __webpack_require__(24849);
// EXTERNAL MODULE: ./components/photo-upload-modal/index.ts + 9 modules
var photo_upload_modal = __webpack_require__(11250);
// EXTERNAL MODULE: ./components/Typography.tsx
var Typography = __webpack_require__(97734);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CloseRounded.js
var CloseRounded = __webpack_require__(36191);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ColorLensRounded.js
var ColorLensRounded = __webpack_require__(35088);
;// CONCATENATED MODULE: ./components/banner-image/tagline-color-selector/tagline-color-selector.style.ts
var root = {};
var colorsContainer = function(isEasyEditable, isOpen) {
    return {
        height: "28px",
        width: isOpen ? "300px" : "28px",
        display: {
            xs: "none",
            md: "inline-flex"
        },
        position: "absolute",
        right: "12px",
        bottom: "12px",
        zIndex: 3,
        overflow: "hidden",
        padding: "7px",
        borderRadius: "6px",
        opacity: isEasyEditable ? 0 : 1,
        transition: "0.3s",
        boxShadow: "0px 0px 7px 0px #00000038",
        gap: "6px",
        alignItems: "center"
    };
};
var overlay = function(isOpen) {
    return {
        top: "0px",
        bottom: "0px",
        left: "0px",
        right: "0px",
        zIndex: 2,
        position: "absolute",
        display: isOpen ? "block" : "none",
        cursor: "pointer"
    };
};
var colorItem = function(color) {
    return {
        height: "20px",
        width: "20px",
        backgroundColor: color,
        ":hover": {
            backgroundColor: color
        }
    };
};


;// CONCATENATED MODULE: ./components/banner-image/tagline-color-selector/tagline-color-selector.tsx











var TaglineColorSelector = function(param) {
    var isEasyEditable = param.isEasyEditable;
    var ref = (0,react.useState)(false), isModalOpen = ref[0], setIsModalOpen = ref[1];
    var userUid = (0,es/* useSelector */.v9)(function(state) {
        return state.user.user.uid;
    });
    var setTaglineColor = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(color) {
            var _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = userUid;
                        if (!_tmp) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,user/* updateSingleUserData */.Pf)(userUid, "taglineColor", color, "Tagline color updated.")
                        ];
                    case 1:
                        _tmp = _state.sent();
                        _state.label = 2;
                    case 2:
                        _tmp;
                        setIsModalOpen(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function setTaglineColor(color) {
            return _ref.apply(this, arguments);
        };
    }();
    var colorData = [
        "#1abc9c",
        "#2ecc71",
        "#3498db",
        "#9b59b6",
        "#34495e",
        "#f1c40f",
        "#e67e22",
        "#e74c3c",
        "#ecf0f1",
        "#95a5a6", 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                id: "basic-button",
                onClick: function() {
                    setIsModalOpen(function(state) {
                        return !state;
                    });
                },
                className: "EditIcon",
                sx: {
                    display: {
                        xs: "none",
                        md: "inline-flex"
                    },
                    opacity: isEasyEditable ? 0 : 1,
                    position: "absolute",
                    right: "10px",
                    bottom: "10px",
                    zIndex: 4,
                    transform: "scale(85%)",
                    padding: "7px",
                    borderRadius: "6px",
                    backgroundColor: Theme/* theme.brand2.500 */.r.brand2[500],
                    transition: "0.3s",
                    boxShadow: "0px 0px 7px 0px #00000038",
                    ":hover": {
                        backgroundColor: Theme/* theme.brand2.600 */.r.brand2[600]
                    }
                },
                component: "label",
                children: isModalOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseRounded/* default */.Z, {
                    sx: {
                        color: "#fff",
                        fontSize: "19px"
                    }
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorLensRounded/* default */.Z, {
                    sx: {
                        color: "#fff",
                        fontSize: "19px"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: overlay(isModalOpen),
                onClick: function() {
                    return setIsModalOpen(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: colorsContainer(isEasyEditable, isModalOpen),
                className: "EditIcon",
                children: colorData.map(function(each, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        sx: colorItem(each),
                        onClick: function() {
                            return setTaglineColor(each);
                        }
                    }, index);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/banner-image/tagline-color-selector/index.ts


;// CONCATENATED MODULE: ./components/banner-image/banner-image.tsx
















var BannerImage = function(_param) {
    var _isEasyEditable = _param.isEasyEditable, isEasyEditable = _isEasyEditable === void 0 ? false : _isEasyEditable, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isEasyEditable"
    ]);
    var userData = (0,es/* useSelector */.v9)(function(state) {
        return state.user.user;
    });
    var ref = (0,react.useState)(false), isImageLoading = ref[0], setIsImageLoading = ref[1];
    var ref1 = (0,react.useState)(false), isPhotoEditModalOpen = ref1[0], setIsPhotoEditModalOpen = ref1[1];
    var handleBannerImageChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(imageFile) {
            var _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsImageLoading(true);
                        if (!imageFile) return [
                            3,
                            3
                        ];
                        _tmp = imageFile && userData.uid;
                        if (!_tmp) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,user/* uploadBannerImage */.xf)(imageFile, userData.uid)
                        ];
                    case 1:
                        _tmp = _state.sent();
                        _state.label = 2;
                    case 2:
                        _tmp;
                        react_toastify_esm/* toast.success */.Am.success("Banner image successfully updated.");
                        _state.label = 3;
                    case 3:
                        setIsImageLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleBannerImageChange(imageFile) {
            return _ref.apply(this, arguments);
        };
    }();
    var isHomePage = window.location.pathname === "/";
    var handleEditButtonClick = function() {
        setIsPhotoEditModalOpen(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            !isEasyEditable && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h2",
                sx: {
                    mb: 3,
                    display: {
                        xs: "none",
                        md: "block"
                    }
                },
                children: "Banner Image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    width: "100%",
                    aspectRatio: "4.25/1",
                    borderRadius: 2,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                    position: "relative",
                    "&:hover  .EditIcon ": {
                        opacity: 1
                    }
                },
                children: [
                    isImageLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        variant: "rounded",
                        sx: {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            zIndex: 4,
                            height: "100%"
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            background: 'url("'.concat(userData.bannerImage ? userData.bannerImage : "/Global/defaultBanner.png", '")'),
                            filter: "brightness(70%)",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            zIndex: 2
                        }
                    }),
                    isHomePage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h3",
                        sx: {
                            color: "".concat(userData.taglineColor ? userData.taglineColor : Theme/* theme.whiteBg.WBG1 */.r.whiteBg.WBG1, " !important"),
                            zIndex: 3,
                            margin: 3,
                            textAlign: "center"
                        },
                        children: userData.tagline
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        onClick: handleEditButtonClick,
                        className: "EditIcon",
                        sx: {
                            opacity: isEasyEditable ? 0 : 1,
                            position: "absolute",
                            right: "10px",
                            top: "10px",
                            zIndex: 3,
                            transform: "scale(85%)",
                            padding: "9px",
                            borderRadius: "6px",
                            backgroundColor: Theme/* theme.brand1.500 */.r.brand1[500],
                            transition: "0.3s",
                            boxShadow: "0px 0px 7px 0px #00000038",
                            ":hover": {
                                backgroundColor: Theme/* theme.brand1.600 */.r.brand1[600]
                            }
                        },
                        component: "label",
                        "aria-label": "delete",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditIcon/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TaglineColorSelector, {
                        isEasyEditable: isEasyEditable
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(photo_upload_modal/* PhotoUploadModal */.f, {
                open: isPhotoEditModalOpen,
                handleClose: function() {
                    setIsPhotoEditModalOpen(false);
                },
                image: userData.bannerImage,
                handleSave: handleBannerImageChange,
                height: 100,
                width: 425,
                borderRadius: 5,
                defaultPhotoSearchQuery: userData.tagline || "Foodie"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/banner-image/index.ts



/***/ }),

/***/ 23752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ browse_ChefProfileCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./assets/Icons/ProfileIcon.tsx
var ProfileIcon = __webpack_require__(42198);
// EXTERNAL MODULE: ./mui-customs/Theme.ts
var Theme = __webpack_require__(24849);
// EXTERNAL MODULE: ./components/Button.tsx
var Button = __webpack_require__(40570);
// EXTERNAL MODULE: ./components/LikeAndUnLikeChef.tsx
var LikeAndUnLikeChef = __webpack_require__(68602);
// EXTERNAL MODULE: ./components/Typography.tsx
var Typography = __webpack_require__(97734);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography_Typography = __webpack_require__(15861);
;// CONCATENATED MODULE: ./components/browse/HourlyRateDisplay.tsx



var HourlyRateDisplay = function(param) {
    var value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            p: "8px 6px",
            background: Theme/* theme.brand2.50 */.r.brand2[50],
            borderRadius: "6px",
            width: "fit-content",
            height: "fit-content"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
            sx: {
                fontSize: "12px",
                lineHeight: "16px",
                fontWeight: "600",
                fontFamily: "Poppins",
                color: Theme/* theme.brand2.850 */.r.brand2[850]
            },
            children: [
                "$",
                value,
                "/Hour"
            ]
        })
    });
};
/* harmony default export */ var browse_HourlyRateDisplay = (HourlyRateDisplay);

;// CONCATENATED MODULE: ./components/browse/ProfileTag.tsx



var ProfileTag = function(param) {
    var text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            p: "4px 8px",
            background: Theme/* theme.whiteBg.WBG3 */.r.whiteBg.WBG3,
            borderRadius: "6px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            sx: {
                fontSize: "12px",
                lineHeight: "16px",
                fontWeight: "400",
                fontFamily: "Poppins",
                color: Theme/* theme.grey2.300 */.r.grey2[300]
            },
            children: text
        })
    });
};
/* harmony default export */ var browse_ProfileTag = (ProfileTag);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Grade.js
var Grade = __webpack_require__(76403);
;// CONCATENATED MODULE: ./components/browse/RatingDisplay.tsx





var RatingDisplay = function(param) {
    var value = param.value, sx = param.sx;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: (0,_object_spread/* default */.Z)({
            background: Theme/* theme.brand1.500 */.r.brand1[500],
            p: " 6px 8px",
            borderRadius: "5px",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            width: "fit-content"
        }, sx),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grade/* default */.Z, {
                sx: {
                    color: Theme/* theme.whiteBg.WBG1 */.r.whiteBg.WBG1,
                    height: "18px",
                    width: "18px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                sx: {
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    lineHeight: "20px",
                    fontWeight: "400",
                    color: Theme/* theme.whiteBg.WBG1 */.r.whiteBg.WBG1
                },
                children: value ? value % 1 !== 0 ? value.toFixed(2) : value : 0
            })
        ]
    });
};
/* harmony default export */ var browse_RatingDisplay = (RatingDisplay);

;// CONCATENATED MODULE: ./components/browse/ChefProfileCard.tsx












var ChefProfileCard = function(param) {
    var chef = param.chef;
    var ref, ref1, ref2, ref3;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            py: 3,
            boxSizing: "border-box",
            width: "100%",
            gap: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            cursor: "pointer"
        },
        onClick: function() {
            router.push("/profile-public/".concat(chef.uid));
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    width: "100%",
                    maxHeight: "300px",
                    borderRadius: "6px",
                    aspectRatio: "327 / 222",
                    position: "relative",
                    overflow: "hidden",
                    backgroundColor: Theme/* theme.whiteBg.WBG3 */.r.whiteBg.WBG3,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                },
                children: chef.profileImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: chef.profileImage,
                    alt: "".concat(chef.firstName, " ").concat(chef.lastName, " profile picture"),
                    layout: "fill",
                    objectFit: "cover",
                    priority: false,
                    loading: "lazy",
                    sizes: "(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileIcon/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-between",
                            gap: 1
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "title6",
                                sx: {
                                    color: Theme/* theme.black.800 */.r.black[800]
                                },
                                children: "".concat(chef.firstName, " ").concat(chef.lastName && chef.lastName[0], ".")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(browse_RatingDisplay, {
                                value: chef.rating
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 1
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    flexDirection: "column",
                                    // gap: 1,
                                    flex: 1
                                },
                                children: [
                                    chef.bio && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        sx: {
                                            position: "relative",
                                            pr: 3,
                                            height: "21px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            sx: {
                                                position: "absolute",
                                                top: 0,
                                                bottom: 0,
                                                left: 0,
                                                right: 0,
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body3",
                                                sx: {
                                                    color: Theme/* theme.grey2.400 */.r.grey2[400],
                                                    textOverflow: "ellipsis",
                                                    overflow: "hidden",
                                                    whiteSpace: "nowrap"
                                                },
                                                children: chef.bio
                                            })
                                        })
                                    }),
                                    ((ref = chef.address) === null || ref === void 0 ? void 0 : ref.locality) && ((ref1 = chef.address) === null || ref1 === void 0 ? void 0 : ref1.state) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        sx: {
                                            position: "relative",
                                            pr: 3,
                                            height: "21px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            sx: {
                                                position: "absolute",
                                                top: 0,
                                                bottom: 0,
                                                left: 0,
                                                right: 0,
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body3",
                                                sx: {
                                                    textOverflow: "ellipsis",
                                                    overflow: "hidden",
                                                    whiteSpace: "nowrap",
                                                    color: Theme/* theme.blue.400 */.r.blue[400]
                                                },
                                                children: "".concat((ref2 = chef.address) === null || ref2 === void 0 ? void 0 : ref2.locality, ", ").concat((ref3 = chef.address) === null || ref3 === void 0 ? void 0 : ref3.state)
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: chef.hourlyRate && /*#__PURE__*/ (0,jsx_runtime.jsx)(browse_HourlyRateDisplay, {
                                    value: chef.hourlyRate
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    justifyContent: "flex-start",
                    gap: 1,
                    flexWrap: "wrap"
                },
                children: chef.foodPreferences && chef.foodPreferences.map(function(tag, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(browse_ProfileTag, {
                        text: tag
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    alignItems: "end",
                    flex: 1
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        width: "100%",
                        gap: 2,
                        alignItems: "center"
                    },
                    children: [
                        chef.uid && /*#__PURE__*/ (0,jsx_runtime.jsx)(LikeAndUnLikeChef/* default */.Z, {
                            chefUid: chef.uid
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: function() {
                                router.push("/profile-public/".concat(chef.uid));
                            },
                            sx: {
                                flexGrow: 1
                            },
                            children: "View Profile"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var browse_ChefProfileCard = (ChefProfileCard);


/***/ }),

/***/ 12050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(99226);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);
/* harmony import */ var _customHooks_useInvoice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36526);
/* harmony import */ var _firebase_finance__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2876);
/* harmony import */ var _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24849);
/* harmony import */ var _redux_financeSlice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76961);
/* harmony import */ var _utils_stripe_helpers__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(61855);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97734);













var FinanceSummaryCard = function() {
    var totalData = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return state.financialSlice;
    }).totalData;
    var user = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return state.user;
    }).user;
    var settings = (0,_customHooks_useInvoice__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().settings;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var calculateTotalFinance = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
            var totalDue, totalPending, totalPaid;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(user.uid && user.userType)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            (0,_firebase_finance__WEBPACK_IMPORTED_MODULE_5__/* .getTotalDueForUser */ .by)(user.uid, user.userType, settings.service_charge)
                        ];
                    case 1:
                        totalDue = _state.sent();
                        return [
                            4,
                            (0,_firebase_finance__WEBPACK_IMPORTED_MODULE_5__/* .getTotalPendingForUser */ .Ds)(user.uid, user.userType, settings.service_charge, settings.deposit_percentage)
                        ];
                    case 2:
                        totalPending = _state.sent();
                        return [
                            4,
                            (0,_firebase_finance__WEBPACK_IMPORTED_MODULE_5__/* .getTotalPaidForUser */ .eF)(user.uid, user.userType, settings.service_charge)
                        ];
                    case 3:
                        totalPaid = _state.sent();
                        dispatch((0,_redux_financeSlice__WEBPACK_IMPORTED_MODULE_7__/* .setTotalData */ .$$)({
                            totalDue: totalDue,
                            totalPaid: totalPaid,
                            totalPending: totalPending
                        }));
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function calculateTotalFinance() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        calculateTotalFinance();
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        sx: {
            backgroundColor: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_6__/* .theme.brand1[200] */ .r.brand1[200],
            width: "100%",
            p: 3,
            borderRadius: 2
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                variant: "h2",
                sx: {
                    color: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_6__/* .theme.black[800] */ .r.black[800],
                    textAlign: "center"
                },
                children: "Financial Summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                sx: {
                    display: "flex",
                    justifyContent: "space-around",
                    mt: 2,
                    position: "relative",
                    "& div": {
                        zIndex: 20,
                        textAlign: "center"
                    },
                    "& div:nth-child(n+4)": {
                        position: "absolute",
                        height: "32px",
                        borderRadius: 5,
                        bottom: 0,
                        left: 0
                    },
                    "& div p:nth-child(2)": {
                        mt: 2,
                        mb: "2px",
                        color: "".concat(_mui_customs_Theme__WEBPACK_IMPORTED_MODULE_6__/* .theme.whiteBg.WBG1 */ .r.whiteBg.WBG1, " !important")
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                variant: "h3",
                                children: "Total Due"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                variant: "h3",
                                children: (0,_utils_stripe_helpers__WEBPACK_IMPORTED_MODULE_12__/* .formatAmountForDisplay */ .RK)(totalData.totalDue, "usd")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                variant: "h3",
                                children: "Total Pending"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                variant: "h3",
                                children: (0,_utils_stripe_helpers__WEBPACK_IMPORTED_MODULE_12__/* .formatAmountForDisplay */ .RK)(totalData.totalDue - totalData.totalPaid, "usd")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                variant: "h3",
                                children: "Total Paid"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                variant: "h3",
                                children: (0,_utils_stripe_helpers__WEBPACK_IMPORTED_MODULE_12__/* .formatAmountForDisplay */ .RK)(totalData.totalPaid, "usd")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        sx: {
                            width: "33%",
                            backgroundColor: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_6__/* .theme.brand2[500] */ .r.brand2[500],
                            zIndex: "19 !important"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        sx: {
                            width: "66%",
                            backgroundColor: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_6__/* .theme.yellow[300] */ .r.yellow[300],
                            zIndex: "18 !important"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        sx: {
                            width: "100%",
                            backgroundColor: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_6__/* .theme.brand1[600] */ .r.brand1[600],
                            zIndex: "17 !important"
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FinanceSummaryCard);


/***/ }),

/***/ 77928:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
function timeSince(date) {
    var currentDate = new Date();
    var seconds = Math.floor((currentDate - date) / 1000);
    var interval = seconds / 31536000;
    if (interval > 1) {
        return "".concat(Math.floor(interval), " year").concat(interval >= 2 ? "s" : "", " ago");
    }
    interval = seconds / 2592000;
    if (interval > 1) {
        return "".concat(Math.floor(interval), " month").concat(interval >= 2 ? "s" : "", " ago");
    }
    interval = seconds / 86400;
    if (interval > 1) {
        return "".concat(Math.floor(interval), " day").concat(interval >= 2 ? "s" : "", " ago");
    }
    interval = seconds / 3600;
    if (interval > 1) {
        return "".concat(Math.floor(interval), " hour").concat(interval >= 2 ? "s" : "", " ago");
    }
    interval = seconds / 60;
    if (interval > 1) {
        return "".concat(Math.floor(interval), " minute").concat(interval >= 2 ? "s" : "", " ago");
    }
    return "".concat(Math.floor(interval), " minute").concat(interval >= 2 ? "s" : "", " ago");
}
/* harmony default export */ __webpack_exports__["Z"] = (timeSince);


/***/ }),

/***/ 73707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./components/banner-image/index.ts + 4 modules
var banner_image = __webpack_require__(30894);
// EXTERNAL MODULE: ./components/finance/FinanceSummaryCard.tsx
var FinanceSummaryCard = __webpack_require__(12050);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Circle.js
var Circle = __webpack_require__(91535);
// EXTERNAL MODULE: ./mui-customs/Theme.ts
var Theme = __webpack_require__(24849);
// EXTERNAL MODULE: ./components/Typography.tsx
var Typography = __webpack_require__(97734);
;// CONCATENATED MODULE: ./components/home/GigActivityCard.tsx







var GigActivityCard = function(param) {
    var iconColor = param.iconColor, label = param.label;
    var router = (0,next_router.useRouter)();
    var userUid = (0,es/* useSelector */.v9)(function(state) {
        return state.user.user.uid;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            py: 2
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    gap: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Circle/* default */.Z, {
                        sx: {
                            color: iconColor,
                            height: "12px",
                            width: "12px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "title2",
                        sx: {
                            color: Theme/* theme.grey2.500 */.r.grey2[500]
                        },
                        children: label
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                onClick: function() {
                    router.push("/gigs/".concat(userUid));
                },
                variant: "text",
                sx: {
                    textTransform: "none",
                    color: Theme/* theme.blue.400 */.r.blue[400],
                    height: "fit-content"
                },
                children: "See all"
            })
        ]
    });
};
/* harmony default export */ var home_GigActivityCard = (GigActivityCard);

// EXTERNAL MODULE: ./components/innerLayout/InnerLayout.tsx + 14 modules
var InnerLayout = __webpack_require__(66570);
// EXTERNAL MODULE: ./node_modules/@mui/material/Badge/Badge.js + 2 modules
var Badge = __webpack_require__(90263);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./assets/Message/FlagIcon.tsx




var FlagIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, dimension = _param.dimension, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color",
        "dimension"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: dimension || 40,
        height: dimension || 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "19.5",
                cy: "19.5",
                r: "19.5",
                fill: color || "#F6CB7A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.75 15.25V27.25",
                stroke: "white",
                strokeWidth: "1.125",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.25 15.25V22",
                stroke: "white",
                strokeWidth: "1.125",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.75 15.2499C15.451 14.5628 16.3934 14.178 17.375 14.178C18.3566 14.178 19.299 14.5628 20 15.2499C20.701 15.937 21.6434 16.3219 22.625 16.3219C23.6066 16.3219 24.549 15.937 25.25 15.2499",
                stroke: "white",
                strokeWidth: "1.125",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.75 21.9999C15.451 21.3128 16.3934 20.928 17.375 20.928C18.3566 20.928 19.299 21.3128 20 21.9999C20.701 22.687 21.6434 23.0719 22.625 23.0719C23.6066 23.0719 24.549 22.687 25.25 21.9999",
                stroke: "white",
                strokeWidth: "1.125",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ var Message_FlagIcon = (FlagIcon);

// EXTERNAL MODULE: ./helper/timeSince.ts
var timeSince = __webpack_require__(77928);
;// CONCATENATED MODULE: ./components/message/Notification/NotificationCard.tsx







var NotificationCard = function(param) {
    var notification = param.notification, onClick = param.onClick, _showSelected = param.showSelected, showSelected = _showSelected === void 0 ? false : _showSelected;
    var selectedNotification = (0,es/* useSelector */.v9)(function(state) {
        return state.notifications;
    }).selectedNotification;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        onClick: function() {
            return onClick(notification);
        },
        sx: {
            width: "100%",
            display: "flex",
            gap: "15px",
            py: 2,
            px: {
                md: 2
            },
            cursor: "pointer",
            backgroundColor: showSelected && (selectedNotification === null || selectedNotification === void 0 ? void 0 : selectedNotification.id) === notification.id ? Theme/* theme.whiteBg.WBG3 */.r.whiteBg.WBG3 : Theme/* theme.whiteBg.WBG1 */.r.whiteBg.WBG1,
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    minHeight: "40px",
                    minWidth: "40px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                    variant: "dot",
                    color: "error",
                    invisible: notification.isRead,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message_FlagIcon, {
                        width: 40,
                        height: 40
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    width: "100%",
                    display: "flex",
                    flexDirection: "column"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        color: Theme/* theme.grey1.400 */.r.grey1[400],
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                        mb: 1
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "title1",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            sx: {
                                color: "".concat(Theme/* theme.black.800 */.r.black[800], " !important"),
                                fontWeight: "600 !important"
                            },
                            children: notification.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "verySmall2",
                            children: (0,timeSince/* default */.Z)(new Date(notification.sentTime))
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Notification_NotificationCard = (NotificationCard);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Person.js
var Person = __webpack_require__(15398);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./firebase/user.ts + 3 modules
var user = __webpack_require__(32012);
// EXTERNAL MODULE: ./components/browse/ChefProfileCard.tsx + 3 modules
var ChefProfileCard = __webpack_require__(23752);
// EXTERNAL MODULE: ./components/NoDataUI.tsx
var NoDataUI = __webpack_require__(89243);
;// CONCATENATED MODULE: ./components/NearbyChefs.tsx










var NearbyChefs = function() {
    var userAddress = (0,es/* useSelector */.v9)(function(state) {
        return state.user.user.address;
    });
    var ref = (0,react.useState)([]), chefsData = ref[0], setChefsData = ref[1];
    function fetchNearByChefs() {
        return _fetchNearByChefs.apply(this, arguments);
    }
    function _fetchNearByChefs() {
        _fetchNearByChefs = (0,_async_to_generator/* default */.Z)(function() {
            var nearByChefs;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!userAddress) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,user/* getNearByChefs */.z5)(userAddress.lat, userAddress.lng)
                        ];
                    case 1:
                        nearByChefs = _state.sent();
                        nearByChefs && setChefsData(nearByChefs);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return _fetchNearByChefs.apply(this, arguments);
    }
    (0,react.useEffect)(function() {
        fetchNearByChefs();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        children: chefsData.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            container: true,
            spacing: 3,
            children: chefsData.map(function(chef, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    md: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChefProfileCard/* default */.Z, {
                        chef: chef
                    })
                }, index);
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NoDataUI/* default */.Z, {
            Icon: Person/* default */.Z,
            displayMessage: "No chefs near you"
        })
    });
};
/* harmony default export */ var components_NearbyChefs = (NearbyChefs);

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/FoodBankOutlined.js
var FoodBankOutlined = __webpack_require__(47433);
// EXTERNAL MODULE: ./firebase/gig.ts + 1 modules
var gig = __webpack_require__(30622);
// EXTERNAL MODULE: ./components/GigCard.tsx
var GigCard = __webpack_require__(59012);
;// CONCATENATED MODULE: ./components/NearbyGigs.tsx










var NearbyGigs = function() {
    var ref = (0,react.useState)([]), gigsData = ref[0], setGigsData = ref[1];
    var userAddress = (0,es/* useSelector */.v9)(function(state) {
        return state.user.user.address;
    });
    var userUid = (0,es/* useSelector */.v9)(function(state) {
        return state.user.user.uid;
    });
    function fetchNearByGigs() {
        return _fetchNearByGigs.apply(this, arguments);
    }
    function _fetchNearByGigs() {
        _fetchNearByGigs = (0,_async_to_generator/* default */.Z)(function() {
            var nearByGigs;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!userAddress) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,gig/* getNearByGigs */.ht)(userAddress.lat, userAddress.lng, userUid || null)
                        ];
                    case 1:
                        nearByGigs = _state.sent();
                        nearByGigs && setGigsData(nearByGigs);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return _fetchNearByGigs.apply(this, arguments);
    }
    (0,react.useEffect)(function() {
        fetchNearByGigs();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            mt: 3
        },
        children: gigsData.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            container: true,
            spacing: 3,
            children: gigsData.map(function(gig, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    md: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GigCard/* default */.Z, {
                        gigStatusDisplay: true,
                        gig: gig
                    })
                }, index);
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NoDataUI/* default */.Z, {
            Icon: FoodBankOutlined/* default */.Z,
            displayMessage: "No gigs near you"
        })
    });
};
/* harmony default export */ var components_NearbyGigs = (NearbyGigs);

// EXTERNAL MODULE: ./constants/BrowseType.ts
var BrowseType = __webpack_require__(30694);
// EXTERNAL MODULE: ./constants/tabs.ts
var tabs = __webpack_require__(28141);
// EXTERNAL MODULE: ./constants/UserType.ts
var UserType = __webpack_require__(22898);
// EXTERNAL MODULE: ./redux/createBrowsePageSlice.ts
var createBrowsePageSlice = __webpack_require__(39954);
// EXTERNAL MODULE: ./redux/createTabSlice.tsx
var createTabSlice = __webpack_require__(89515);
// EXTERNAL MODULE: ./redux/notificationSlice.ts
var notificationSlice = __webpack_require__(10415);
;// CONCATENATED MODULE: ./pages/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  border-radius: 16px;\n  padding: 24px;\n  border: 2px solid ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}























var StyledContainer = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z)(_templateObject(), Theme/* theme.whiteBg.WBG3 */.r.whiteBg.WBG3);
var Home = function() {
    var ref = (0,react.useState)(false), isBannerImageLoading = ref[0], setIsBannerImageLoading = ref[1];
    var isMdSize = (0,useMediaQuery/* default */.Z)("(min-width:900px)");
    var dispatch = (0,es/* useDispatch */.I0)();
    var userData = (0,es/* useSelector */.v9)(function(state) {
        return state.user.user;
    });
    var notificationData = (0,es/* useSelector */.v9)(function(state) {
        return state.notifications.notifications;
    });
    var router = (0,next_router.useRouter)();
    var hasLoggedInitial = (0,react.useRef)(false);
    var LOG_PREFIX = "[HomePage]";
    (0,react.useEffect)(function() {
        dispatch((0,createTabSlice/* setTab */.IE)(tabs/* default.Home */.Z.Home));
    }, []);
    (0,react.useEffect)(function() {
        var shouldRedirect = (!userData.uid || !isMdSize) && router.asPath === "/";
        console.log(router.asPath === "/");
        if (shouldRedirect) {
            console.info(LOG_PREFIX, "redirectingToBrowse", {
                path: router.asPath,
                host:  true ? window.location.hostname : 0,
                uidPresent: Boolean(userData.uid),
                isMdSize: isMdSize,
                reason: !userData.uid ? "missing-uid" : !isMdSize ? "below-md" : "unknown"
            });
            console.log("From Index");
            router.replace("/browse");
            return;
        }
        console.info(LOG_PREFIX, "stayingOnHome", {
            path: router.asPath,
            host:  true ? window.location.hostname : 0,
            uidPresent: Boolean(userData.uid),
            isMdSize: isMdSize
        });
    }, [
        isMdSize
    ]);
    // Log key state once on initial render and when critical values change
    (0,react.useEffect)(function() {
        // Log once on first client render
        if (!hasLoggedInitial.current) {
            hasLoggedInitial.current = true;
            console.info(LOG_PREFIX, "mount", {
                path: router.asPath,
                host:  true ? window.location.hostname : 0,
                uidPresent: Boolean(userData.uid),
                userType: userData.userType,
                isMdSize: isMdSize,
                notifications: notificationData.length
            });
            return;
        }
        // Subsequent concise deltas
        console.info(LOG_PREFIX, "stateChange", {
            path: router.asPath,
            host:  true ? window.location.hostname : 0,
            uidPresent: Boolean(userData.uid),
            userType: userData.userType,
            isMdSize: isMdSize,
            notifications: notificationData.length
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        userData.uid,
        userData.userType,
        isMdSize,
        notificationData.length
    ]);
    var onNotificationClick = function(notification) {
        router.push("/message");
        dispatch((0,notificationSlice/* setSelectedNotification */.xQ)(notification));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            width: "100%",
            backgroundColor: Theme/* theme.whiteBg.WBG1 */.r.whiteBg.WBG1,
            display: "flex",
            flexDirection: "column",
            gap: 3,
            p: 3
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(banner_image/* BannerImage */.c, {
                isEasyEditable: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FinanceSummaryCard/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h2",
                        sx: {
                            color: Theme/* theme.black.800 */.r.black[800]
                        },
                        children: "Latest Gig Activity"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            mt: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(home_GigActivityCard, {
                                iconColor: Theme/* theme.brand1.300 */.r.brand1[300],
                                label: "Accepted/Booked"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(home_GigActivityCard, {
                                iconColor: Theme/* theme.grey1.200 */.r.grey1[200],
                                label: "Draft Phase"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(home_GigActivityCard, {
                                iconColor: Theme/* theme.pink.200 */.r.pink[200],
                                label: "Awaiting Payment"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(home_GigActivityCard, {
                                iconColor: Theme/* theme.purple.200 */.r.purple[200],
                                label: "Open Bid"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(home_GigActivityCard, {
                                iconColor: Theme/* theme.yellow.200 */.r.yellow[200],
                                label: "Invoice Change (0)"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h2",
                                sx: {
                                    color: Theme/* theme.black.800 */.r.black[800],
                                    mt: 2
                                },
                                children: "Recent Notifications & Messages"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "text",
                                sx: {
                                    textTransform: "none",
                                    color: Theme/* theme.blue.400 */.r.blue[400],
                                    height: "fit-content"
                                },
                                onClick: function() {
                                    router.push("/message");
                                },
                                children: "See all"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, {
                        sx: {
                            mt: 4
                        },
                        children: notificationData.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: notificationData.slice(0, 5).map(function(notification) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationCard, {
                                    notification: notification,
                                    onClick: function() {
                                        return onNotificationClick(notification);
                                    }
                                }, notification.notificationId);
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NoDataUI/* default */.Z, {
                            displayMessage: "No Notifications found"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h2",
                                sx: {
                                    color: Theme/* theme.black.800 */.r.black[800],
                                    mt: 2
                                },
                                children: "Highlighted ".concat(userData.userType == UserType/* default.Client */.Z.Client ? "Chefs" : "Gigs", " Near You")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "text",
                                sx: {
                                    textTransform: "none",
                                    color: Theme/* theme.blue.400 */.r.blue[400],
                                    height: "fit-content"
                                },
                                onClick: function() {
                                    userData.userType === UserType/* default.Client */.Z.Client && dispatch((0,createBrowsePageSlice/* setActiveTab */.r7)(BrowseType/* default.Chef */.Z.Chef));
                                    router.push("/browse");
                                },
                                children: "Browse ".concat(userData.userType == UserType/* default.Client */.Z.Client ? "chefs" : "gigs")
                            })
                        ]
                    }),
                    userData.userType === UserType/* default.Client */.Z.Client ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NearbyChefs, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NearbyGigs, {})
                ]
            })
        ]
    });
};
Home.getLayout = function getLayout(component) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerLayout/* default */.Z, {
        children: component
    });
};
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4838,8809,9066,6886,1558,6570,4390,6526,9012,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);